module.exports = __webpack_public_path__ + "img/zsgg-10.9046a6ee.png";